export default "__VITE_ASSET__BrmMdDCT__"